/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBellDollar = createReactComponent("bell-dollar", "IconBellDollar", [
  [
    "path",
    {
      d: "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 3.911 5.17",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 17v1a3 3 0 0 0 4.02 2.822", key: "svg-1" }],
  [
    "path",
    {
      d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M19 21v1m0 -8v1", key: "svg-3" }]
]);

export { IconBellDollar as default };
//# sourceMappingURL=IconBellDollar.js.map
